import { Toaster } from '@/components/ui/sonner';
import { Outlet } from 'react-router-dom';

export default function PublicLayout() {
  return (
    <div className="min-h-screen bg-background">
      <Outlet />
      <Toaster position="top-right" />
    </div>
  );
}
